import { batchActions } from 'redux-batched-actions';

import { setAllFieldsValid, updateFieldState } from '@gef-ui/redux-common/actions/fieldState';
import { updateFormState } from '@gef-ui/redux-common/actions/formState';
import { clearGlobalErrors, updateGlobalErrors } from '@gef-ui/redux-common/actions/globalErrors';
import {
	formActionsFactory as gefFromActionsFactory,
	setAllFieldsDirty,
	updateFieldValue,
	validateForm,
} from '@gef-ui/redux-form/actions/form';
import { unregisterField } from '@gef-ui/redux-form/actions/registeredField';
import { validateField } from '@gef-ui/validations/actions/validate';

const formActionsFactory = (name) => {
	const formActions = gefFromActionsFactory(name)[name];

	const globalErrorActions = {
		updateGlobalErrors: updateGlobalErrors(name),
		clearGlobalErrors: clearGlobalErrors(name),
	};

	const fieldStateActions = {
		updateFieldState: updateFieldState(name),
		updateFieldValue: updateFieldValue(name),
		setAllFieldsValid: setAllFieldsValid(name),
		validateField: validateField(name),
	};

	const formStateActions = {
		updateFormState: updateFormState(name),
		validateForm: validateForm(name),
		setAllFieldsDirty: setAllFieldsDirty(name),
	};

	return {
		...formActions,
		...globalErrorActions,
		...fieldStateActions,
		...formStateActions,
		unregisterField: unregisterField(name),
		toInitialState: batchActions.bind(null, [
			formActions.resetForm(),
			globalErrorActions.clearGlobalErrors(),
			fieldStateActions.setAllFieldsValid(),
			formStateActions.updateFormState({ pristine: true }),
		]),
		resetAndReplace: (formData) =>
			batchActions([
				formActions.replaceData({ formData }),
				globalErrorActions.clearGlobalErrors(),
				fieldStateActions.setAllFieldsValid(),
				formStateActions.updateFormState({ pristine: true }),
			]),
	};
};

export default formActionsFactory;
